import { cx } from '@/lib/utils'

interface SkeletonProps {
  className?: string
}

// Sized/shaped by the caller via className so it can stand in for whatever content is
// loading (a heading, an avatar, a chart) without the page's layout shifting once real
// content replaces it — unlike a centered spinner, which collapses to nothing.
export function Skeleton({ className }: SkeletonProps) {
  return <div className={cx('animate-pulse rounded-md bg-gray-200', className)} />
}
